/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const storeCandidateEmailDataSchema = z.object({
	subject: z.string().nullable().optional(),
	body: z.string(),
})

export type StoreCandidateEmailDataSchema = z.infer<typeof storeCandidateEmailDataSchema>
